import { useContext,useState } from "react";
import { TimerContext } from "../../../context/TimerContext";
import { Close } from "../../Icons/Icons";
import Modal from "../Modal";

const SensorStatus = ({hide})=>{
    const { isConnected, arduinoConnected, reconnect } = useContext(TimerContext);
    const [state, setState] = useState({
        api_server:localStorage.getItem("api_server") || null
    });
    const onChangeHandler = (event) => {
        const {name, value} = event.target;
        setState({...state, [name]: value});
    };
    return(
        <Modal>
            <div className="relative">
                <button className="text-lg absolute right-2 -top-1" onClick={hide}>
                    <Close/>
                </button> 
                <div className="border-b mb-2">
                    <div className="font-bold text-md ml-4 mt-2">Server Status</div>
                </div>
                <div className="px-8 py-2">
                    <h2 className="p-2">Server Status: {isConnected ? "🟢 Online" : "🔴 Offline"}</h2>
                    <h2 className="p-2">Arduino Status: {arduinoConnected ? "🟢 Connected" : "🔴 Disconnected"}</h2>
                    <div className="flex gap-2 items-center font-semibold">
                        <label>Server</label>
                        <input
                            className="truncate block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent focus:border-blue-600 border appearance-none focus:outline-none focus:ring-0 peer rounded-lg px-[15px] disabled:cursor-not-allowed"
                            onChange={onChangeHandler} name="api_server" type="text" value={state.api_server} placeholder="http://192.168.1.100:3000"/>
                    </div>
                    {/* {!isConnected && ( */}
                    <button 
                        onClick={reconnect} 
                        style={{ padding: "10px", marginTop: "10px", cursor: "pointer" }}
                    >
                        🔄 Reconnect
                    </button>
                    {/* )} */}
                </div>
            </div>
        </Modal>
    );
};

export default SensorStatus;
